// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"198":"7bb984da","297":"e5e4c3dd","643":"7aa02ae2","703":"842cc293"}[chunkId] + ".chunk.js";
};